import React from "react";
import { Navigate } from "react-router-dom";
import { isFacebookCampaign } from "../utils/Helpers";
const ProtectedRoute = ( { component: Component, ...rest } ) => {
  let isLoggedIn = false;
  const uid = localStorage?.getItem("uid");
  const msisdn=localStorage?.getItem("msisdn")
  const status = localStorage?.getItem("subStatus");
  if (isFacebookCampaign() || ((uid || msisdn)  && status?.toLowerCase()==='active')) {
    isLoggedIn = true;
  }

  if (isLoggedIn) {
    return <Component {...rest} />;
  } else {
    return <Navigate to="/subs/packs" replace/>
  }
};

export default ProtectedRoute;